import styled, { css } from 'styled-components'
import { Box, Modal } from '@mui/material'

interface IContainerProps {
  width?: string
}

export const Wrapper = styled(Modal).attrs({
  'data-testid': 'wrapper-modal',
})(() => css``)

export const Container = styled(Box)<IContainerProps>(
  ({ theme, width }) => css`
    && {
      overflow-y: auto;
      border-radius: ${theme.layout.borderRadius.medium};
      background-color: ${theme.colors.base.white};
      box-shadow: 0 0.1rem 0.5rem ${theme.colors.base.shadow.alpha2};

      left: 50%;
      min-width: ${width || '50%'};
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);

      @media (max-width: ${theme.screen.medium}) {
        border-radius: ${theme.layout.borderRadius.medium}
          ${theme.layout.borderRadius.medium} 0 0;
        bottom: 0;
        left: 0;
        min-height: 20rem;
        min-width: 100%;
        top: unset;
        transform: unset;
      }
    }
  `
)
